<template>
  <div>
    <div class="breadcrumb">
      <div @click="toHome">工作报告</div>
      <img src="../../../../../../assets/channel/login/info.png" alt="">
      <div style="color: #00266d;">全屏填写</div>
    </div>
    <!-- 顶部开始 -->
    <div class="WorkReportTable-Com">
      <div class="WorkReportTable-Com-Top">
        <!-- <img src="../../../../../../assets/channel/login/leftLogin.png" alt="">
        <div class="WorkReportTable-Com-Title">
          2022年2月-工作报表
        </div>
        <img src="../../../../../../assets/channel/login/right.png" alt=""> -->
      </div>
      <!-- 顶部结束 -->

      <!-- 底部表格开始 -->
      <div class="WorkReportTable-Com-Table">
        <Commontable class="overflow-y: scroll;"
         :LNQNKZDGptionsDisabled="LNQNKZDGptionsDisabled"
          :LNZZDGptionsDisabled="LNZZDGptionsDisabled"
           :LNZCDGptionsDisabled="LNZCDGptionsDisabled"
            :YDTLDYGptionsDisabled="YDTLDYGptionsDisabled"
             :PQDYGptionsDisabled="PQDYGptionsDisabled"
              :THQOptionsDisabled="THQOptionsDisabled"
               :QSZJOptionsDisabled="QSZJOptionsDisabled"
                :YCXOptionsDisabled="YCXOptionsDisabled" 
                 @onRowClick="onRowClick" width="1300px" colnum=7 :fontSizeTable="10"
                  :PTAOptionsDisabled="PTAOptionsDisabled" :HPOptionsDisabled="HPOptionsDisabled"
                   :DCBOptionsDisabled="DCBOptionsDisabled" :GCOptionsDisabled="GCOptionsDisabled"
                   :DetailRemarkdisabled="DetailRemarkdisabled"
                    :tableData="TableData" :headerData="headerDataTable" height="100%">
        </Commontable>

        <div class="right" style="margin-right: -10px;">
          <Commonbtn btnType="btn" backgroundColor="#E71D43" width="92px" height="32px" title="提交报表" color="#FFFFFF" @btnclick="SubmitReport">
          </Commonbtn>
          <!-- <Commonbtn btnType="btn" backgroundColor="#E71D43" width="92px" height="32px" title="取消选择" color="#FFFFFF" @btnclick="NO">
          </Commonbtn> -->
        </div>
      </div>
      <!-- 底部表格结束 -->
    </div>

  </div>
</template>

<script>
import Commontable from '../../../../../../components/common-table.vue'
import Commonbtn from '../../../../../../components/common-btn.vue'
import headerDataTable from '../components/components/FromData/headerData'
import {
  HospitalProcessList,
  HospitalEditProcess
} from '@/api/channel'
export default {
  components: { Commontable, Commonbtn },
  props: {},
  data() {
    return {
      TableData: [],
      headerDataTable: [],
      PTAOptionsDisabled: false, //table表格中的下拉列表是否可用
      HPOptionsDisabled: false,//table表格中的下拉列表是否可用
      DCBOptionsDisabled: false,//table表格中的下拉列表是否可用
      GCBOptionsDisabled: false,//table表格中的下拉列表是否可用
      GCOptionsDisabled: false,
      YCXOptionsDisabled: false,
      QSZJOptionsDisabled: false,
      THQOptionsDisabled: false,
      PQDYGptionsDisabled: false,
      YDTLDYGptionsDisabled: false,
      LNZCDGptionsDisabled: false,
      LNZZDGptionsDisabled: false,
      LNQNKZDGptionsDisabled: false,
      DetailRemarkdisabled: false,
      InvClass: '',
      pageindex: 1,
      pagesize: 10,
      total: 0
    }
  },
  created() {
    this.hospitalProcessList()
  },
  mounted() {
    // this.headerDataTable = JSON.parse(JSON.stringify(headerDataTable))
  },
  activated() { },
  updated() { },
  methods: {
    toHome() {
      this.$router.push({
        path: '/homeCom/WorkReport',
        query: {
          MenuID: "78",
          NodeID: "77"
        }
      })
    },
    // NO(row){
    //   console.log(this.$refs.WorkReportTable.$refs.multipleTable.setCurrentRow(row));
    // },
    //报表列表
    async hospitalProcessList() {
      const loading = this.$loading({
        lock: true,
        text: '正在加载列表...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });

      let {
        code,
        data,
        message
      } = await HospitalProcessList({
        // pageSize: this.pagesize,
        // pageIndex: this.pageindex
      })
      if (code == 0) {
        this.InvClass = data.InvClass
        this.total = data.Count
        this.headerDataTable = data.ColumnSettings
        this.TableData = data.data
      } else {
        this.$notify.error({
          title: '提示',
          message: message
        })
      }
      loading.close();
    },
    // 提交报表
    async hospitalEditProcess() {
      let WorkReportArr = []
      this.TableData.map((item, index) => {
        let obj = null
        if (this.InvClass == '101') {
          obj = {
            id: item.ID,
            updateContent: {
               [this.headerDataWorkReport.filter(item => item.prop == 'PTA高压球囊扩张导管')[0].prop]: item.PTA高压球囊扩张导管Options.selected == "" ? null : item.PTA高压球囊扩张导管Options.selected,
              [this.headerDataWorkReport.filter(item => item.prop == 'PTA球囊扩张导管')[0].prop]: item.PTA球囊扩张导管Options.selected == "" ? null : item.PTA球囊扩张导管Options.selected,
              [this.headerDataWorkReport.filter(item => item.prop == '腔静脉滤器抓捕器')[0].prop]: item.腔静脉滤器抓捕器Options.selected == "" ? null : item.腔静脉滤器抓捕器Options.selected,
              [this.headerDataWorkReport.filter(item => item.prop == '外周球囊扩张导管')[0].prop]: item.外周球囊扩张导管Options.selected == "" ? null : item.外周球囊扩张导管Options.selected,
              [this.headerDataWorkReport.filter(item => item.prop == '药物洗脱PTA球囊扩张导管')[0].prop]: item.药物洗脱PTA球囊扩张导管Options.selected == "" ? null : item.药物洗脱PTA球囊扩张导管Options.selected,
              [this.headerDataWorkReport.filter(item => item.prop == '抓捕器')[0].prop]: item.抓捕器Options.selected == "" ? null : item.抓捕器Options.selected,
              DetailRemark: item.DetailRemark
            }
          }
        }
        if (this.InvClass == '102') {
          obj = {
            id: item.ID,
            updateContent: {
              [this.headerDataWorkReport.filter(item => item.prop == '弹簧圈系统')[0].prop]: item.弹簧圈系统Options.selected == "" ? null : item.弹簧圈系统Options.selected,
               [this.headerDataWorkReport.filter(item => item.prop == '颅内球囊扩张导管')[0].prop]: item.颅内球囊扩张导管Options.selected == "" ? null : item.颅内球囊扩张导管Options.selected,
               [this.headerDataWorkReport.filter(item => item.prop == '颅内支撑导管')[0].prop]: item.颅内支撑导管Options.selected == "" ? null : item.颅内支撑导管Options.selected,
               [this.headerDataWorkReport.filter(item => item.prop == '颅内支持导管')[0].prop]: item.颅内支持导管Options.selected == "" ? null : item.颅内支持导管Options.selected,
               [this.headerDataWorkReport.filter(item => item.prop == '球囊导引导管')[0].prop]: item.球囊导引导管Options.selected == "" ? null : item.球囊导引导管Options.selected,
               [this.headerDataWorkReport.filter(item => item.prop == '取栓支架')[0].prop]: item.取栓支架Options.selected == "" ? null : item.取栓支架Options.selected,
               [this.headerDataWorkReport.filter(item => item.prop == '一次性使用微导管')[0].prop]: item.一次性使用微导管Options.selected == "" ? null : item.一次性使用微导管Options.selected,
               [this.headerDataWorkReport.filter(item => item.prop == '远端通路导引导管')[0].prop]: item.远端通路导引导管Options.selected == "" ? null : item.远端通路导引导管Options.selected,
              DetailRemark: item.DetailRemark
            }
          }
        }
        WorkReportArr.push(obj)
      })
      let {
        code,
        data,
        message
      } = await HospitalEditProcess(
        WorkReportArr
      )
      if (code == 0) {
        this.$notify.success({
          title: '提示',
          message: `${message}并已退出编辑模式`
        })


        this.EditFalg = true
        this.hospitalEditProcessFalg = true
        this.DetailRemarkdisabled = true
        this.hospitalProcessList()
      } else {
        this.$notify.error({
          title: '提示',
          message: message
        })
      }
    },
    SubmitReport() {
      this.hospitalEditProcess()
    },
    onRowClick(val) {

    }
  },
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
.WorkReportTable-Com {
  width: 1200px;
  min-height: 1206px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #e6e8eb;
  margin: 16px auto;
  position: relative;
  top: 16px;
  user-select: none;
  overflow-y: scroll;
  margin-bottom: 80px;
  .WorkReportTable-Com-Table {
    margin-left: 14px;
    margin-right: 24px;
  }
}

.breadcrumb {
  width: 1200px;
  //   border: 1px solid red;
  margin: 0 auto;
  position: relative;
  top: 19px;
  margin-bottom: 23px;
  div:nth-child(1):hover {
    color: #e71d43;
  }

  img {
    position: relative;
    top: 3px;
    margin-left: 10px;
    margin-right: 10px;
  }
  div:nth-child(1) {
    color: #9ca5b8;
  }

  div {
    font-size: 14px;
    font-weight: 500;
    display: inline-block;
    cursor: pointer;
  }
}

.WorkReportTable-Com-Top {
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #00266d;
  //   border: 1px solid red;
  padding-top: 26px;
  padding-bottom: 26px;
  padding-left: 40%;

  .WorkReportTable-Com-Title {
    display: inline-block;
    margin-left: 16px;
    margin-right: 16px;
  }
}
</style>